import type { FunctionComponent, ReactChild } from 'react';

import type { BuildWithRevision } from '../../types';

import ProjectBuildItem from './ProjectBuildItem';
import type { ProjectDashboardRevision } from './projectDashboardTypes';

type Props = {
  builds: BuildWithRevision[];
  children?: ReactChild;
  onLatestComplete?(): void;
  currentRevision?: ProjectDashboardRevision;
};

const BuildList: FunctionComponent<Props> = ({
  builds,
  onLatestComplete,
  children,
  currentRevision,
}: Props) => {
  const buildList = builds.map((build) => {
    let { revision } = build;
    if (revision?.locator === currentRevision?.data?.locator) {
      revision = {
        ...revision,
        isSteady: currentRevision.data.isSteady,
      };
    }
    return (
      <ProjectBuildItem
        key={build.id}
        id={build.id}
        onComplete={onLatestComplete}
        revision={revision}
        task={build.task}
        error={build.error}
      />
    );
  });

  return (
    <div>
      { builds.length === 0 ? children || '' : buildList }
    </div>
  );
};

export default BuildList;
